import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { ApiNote } from '@/lib/adapters/notes';

interface NotesResponse {
  data: ApiNote[];
  pagination?: { page: number; limit: number; total: number; totalPages: number };
}

/** Notes, newest first. `limit` asks for more than the default page; `enabled: false` holds the request. */
export function useNotes(options: { enabled?: boolean; limit?: number } = {}) {
  const path = options.limit ? `/notes?limit=${options.limit}` : '/notes';
  return useQuery({
    queryKey: ['notes', { limit: options.limit }],
    queryFn: () => api.get<NotesResponse>(path),
    enabled: options.enabled ?? true,
  });
}
